import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {CustomAxiosError, useApiCalls} from "../../../../../../logics/api_config";
import {useAuth} from "../../../../../../utils/contexts/auth-context";
import {IWasteCode} from "../../../../../../utils/interfaces/special_wasty/waste_code/IWasteCode";


const useApiGetWasteCode = (pk: number | undefined, site_id: number | undefined): UseQueryResult<IWasteCode, CustomAxiosError> => {
    const {selectedCompany} = useAuth();

    const {get} = useApiCalls()

    async function doGet(pk: number | undefined): Promise<IWasteCode> {
        try {
            const response = await get(`/api/company/${selectedCompany?.company_token}/special_wasty/waste_code/${pk}?site_id=${site_id}`);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ["useApiGetWasteCode", pk, site_id],
        queryFn: () => doGet(pk),
        enabled: !!pk && !!site_id,
    })

};

export default useApiGetWasteCode